module.exports = __webpack_public_path__ + "static/media/HomePageMultiply_72dpi.0c3ee2ab.png";